//菜单store
import {VuexStore} from '@/core/storage'
import {treeDataTranslate} from '@/utils'
import menus from '@/menu'

const menuStore = {
    state: {
        menuList: VuexStore.getValue('menuList'),
        authList: undefined,
    },
    mutations: {
        setMenuList: (state, list) => {
            if (VuexStore.storageValue('menuList', list))
                state.menuList = list;
        },
        setAuthList: (state, list) => {
            state.authList = list;
        }
    },
    getters: {
        getMenuList: (state) => {
            return treeDataTranslate(state.menuList, 'menuId', 'parentId');
        },
        getAuthList: (state) => {
            return state.authList;
        }
    },
    actions: {
        
    }
};

export default {
    state: menuStore.state,
    mutations: menuStore.mutations,
    getters: menuStore.getters,
    actions: menuStore.actions
}


// WEBPACK FOOTER //
// ./src/store/modules/menuStore.js